import axios from 'axios';

const request = axios.create({
  baseURL: 'http://18.208.167.61/'
});

export default request;



// WEBPACK FOOTER //
// ./src/components/client/client.js